import styled from 'styled-components';
import { colors } from '../GlobalStyles';

const ServicesContainer = styled.section`
  background: ${colors.primaryDark};
  padding: 5rem 2rem;
  text-align: center;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 4rem 1rem;
    min-height: 500px;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  color: ${colors.accentOrange};
  margin-bottom: 3rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto 3rem auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const ServiceCard = styled.div`
  background: ${colors.lightBeige};
  padding: 2.5rem 2rem;
  border-radius: 8px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

const ServiceIcon = styled.div`
  font-size: 3rem;
  color: ${colors.accentOrange};
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const ServiceTitle = styled.h3`
  font-size: 1.5rem;
  color: ${colors.textDark};
  margin-bottom: 1rem;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

const ServiceDescription = styled.p`
  color: ${colors.textGray};
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export function ServicesSection() {
  const services = [
    {
      icon: '☁️',
      title: 'Cloud Architecture',
      description:
        'Design and implement scalable cloud solutions using modern platforms like GCP, AWS, and Azure.'
    },
    {
      icon: '⚡',
      title: 'Microservices',
      description:
        'Build robust, scalable microservice architectures that can grow with your business needs.'
    },
    {
      icon: '🔧',
      title: 'DevOps Solutions',
      description:
        'Streamline your development pipeline with automated testing, deployment, and monitoring.'
    },
    {
      icon: '📱',
      title: 'Full-Stack Development',
      description: 'End-to-end application development using modern frameworks and best practices.'
    }
  ];

  return (
    <ServicesContainer id="services">
      <SectionTitle>What we can offer your company</SectionTitle>
      <ServicesGrid>
        {services.map((service, index) => (
          <ServiceCard key={index}>
            <ServiceIcon>{service.icon}</ServiceIcon>
            <ServiceTitle>{service.title}</ServiceTitle>
            <ServiceDescription>{service.description}</ServiceDescription>
          </ServiceCard>
        ))}
      </ServicesGrid>
    </ServicesContainer>
  );
}
